// Offline/online connectivity banner (Task 13.7).
//
// Displays the exact offline string while the browser is offline (Req 29.7)
// and is removed within 2 seconds of returning online (Req 29.8) — the
// `online` event fires on transition, so removal is immediate.

import { useEffect, useState } from "react";
import { useOnlineStatus } from "../hooks/useOnlineStatus";

export const OFFLINE_MESSAGE =
  "You're offline. Some features may not be available." as const;

export function OfflineBanner(): JSX.Element | null {
  const online = useOnlineStatus();
  const [showBackOnline, setShowBackOnline] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    if (!online) {
      setWasOffline(true);
      setShowBackOnline(false);
      return;
    }
    if (wasOffline) {
      setShowBackOnline(true);
      const t = setTimeout(() => setShowBackOnline(false), 2000);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [online, wasOffline]);

  if (!online) {
    return (
      <div className="sb-banner sb-banner--offline" role="status">
        {OFFLINE_MESSAGE}
      </div>
    );
  }

  if (showBackOnline) {
    return (
      <div className="sb-banner sb-banner--online" role="status">
        Back online.
      </div>
    );
  }

  return null;
}
